export default {
  // Логика определения подключения самозанятого
  checkSelfEmployed(merchant) {
    return merchant.selfEmployed;
  },
  // Логика определения подключенного телеграмм бота
  checkBotSigned(merchant) {
    return merchant.botSigned;
  },
};
